import { Box, Button, Flex, InputTypeTextReduced } from '@gmg/gmg-react-components';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

export interface RequestTemporaryLicensesModalProps {
    onCloseModal: () => void;
    onSubmit: () => void;
    serialNumber: string;
}

const RequestTemporaryLicensesModal: FC<RequestTemporaryLicensesModalProps> = (props) => {
    const { t } = useTranslation();

    return (
        <Flex mr="24px" ml="24px" flexDirection="column">
            <Flex flexDirection="column" gap='24px'>
                <Box className="px12_400_normal">
                    {t('RequestTemporaryLicensesModal.youCanRequest_firstParagraph_desc', 'You can request a generic GMG license package for empty license systems. This package includes our core products pre-configured for a swift setup of GMG software on a fresh system, especially useful in disaster recovery scenarios.')}
                </Box>
                <Box className="px12_400_normal">
                    {t('RequestTemporaryLicensesModal.youCanRequest_secondParagraph_desc', 'The license package will be automatically sent to the system with the displayed serial number within 2-3 minutes. Please note that the licenses are valid for a limited period of a few days.')}
                </Box>
            </Flex>
            <Flex>
                <StyledLabel
                    className="px10_400_normal"
                    htmlFor="serialNumber">
                    {t('RequestTemporaryLicensesModal.input_serialNumber_label', 'Serial number')}
                </StyledLabel>
            </Flex>
            <Flex height="36px" mb="40px" pt="8px">
                <InputTypeTextReduced
                    id="serialNumber"
                    defaultValue={props.serialNumber}
                    width={'100%'}
                    readOnly
                />
            </Flex>
            <Flex justifyContent="flex-end" gap="10px">
                <Button
                    variant="primary"
                    type="submit"
                    onClick={() =>{
                        props.onSubmit();
                        props.onCloseModal();
                    }}
                >
                    {t('RequestTemporaryLicenses.action_submit_btn', 'Request')}
                </Button>
                <Button
                    variant="secondary"
                    type="reset"
                    onClick={props.onCloseModal}
                >
                    {t('ButtonTitles.action_cancel_btn', 'Cancel')}
                </Button>
            </Flex>
        </Flex>
    );
};

const StyledLabel = styled.label`
    margin-top: 30px;
    box-sizing: border-box;
    height: 20px;
`;

export default RequestTemporaryLicensesModal;